const React = require("react")
const InterfaceOnline = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="#3C4646"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M3.02441 6.73684H15.656V5.33333H3.02441C2.25248 5.33333 1.6209 5.96491 1.6209 6.73684V14.4561H0.217392V16.5614H10.042V14.4561H3.02441V6.73684ZM16.3577 8.14035H12.1472C11.7613 8.14035 11.4455 8.45613 11.4455 8.8421V15.8596C11.4455 16.2456 11.7613 16.5614 12.1472 16.5614H16.3577C16.7437 16.5614 17.0595 16.2456 17.0595 15.8596V8.8421C17.0595 8.45613 16.7437 8.14035 16.3577 8.14035ZM15.656 14.4561H12.849V9.54385H15.656V14.4561Z" />
      <path d="M17.3577 2.68421L17.9542 3.2807C19.4365 1.79842 21.8404 1.79842 23.3227 3.2807L23.9191 2.68421C22.1088 0.873859 19.1711 0.873859 17.3577 2.68421ZM19.7437 5.07017L20.6384 5.96491L21.5332 5.07017C21.0411 4.57509 20.2388 4.57509 19.7437 5.07017ZM18.5507 3.87719L19.1472 4.47368C19.9704 3.65053 21.3065 3.65053 22.1297 4.47368L22.7262 3.87719C21.5749 2.72596 19.7049 2.72596 18.5507 3.87719Z" />
    </svg>
  )
}

module.exports = {
  InterfaceOnline
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/menu/icons/interfaceOnline.js